import { toaster } from '@/components/ui/toaster';

export const errorToast = (
  title = 'Ett fel upstod',
  description = 'Vi kunde inte hantera din begäran, vänligen försök igen eller kontakta oss',
  duration = 10000
) => {
  toaster.error({
    title,
    duration,
    description,
  });
};
